// utils/searchHistory.js — riwayat halaman yang dibuka lewat Quick Search.
// ─────────────────────────────────────────────────────────────────────────────
// Disimpan di localStorage, per perangkat. SENGAJA tidak dikirim ke server:
// isinya hanya kenyamanan, dan menyimpannya di profil pengguna berarti riwayat
// penelusuran satu orang bisa terbaca dari perangkat lain — biaya privasi yang
// tidak sebanding dengan manfaat "dua klik jadi satu".
//
// Yang disimpan adalah HASIL YANG DIPILIH (halaman/tab), bukan teks yang
// diketik. Teks ketikan sering salah eja atau setengah jadi ("mont", "sap ro"),
// dan menawarkannya kembali sebagai saran hanya mengulang pekerjaan. Yang
// benar-benar berguna adalah tujuannya.

const KEY = 'quicksearch.recent';
const MAX = 8;

export function readHistory() {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter(x => x && x.id && x.path) : [];
  } catch {
    // Private mode, kuota penuh, atau JSON rusak. Riwayat adalah pelengkap —
    // kegagalannya tidak boleh membuat kotak pencarian ikut mati.
    return [];
  }
}

export function pushHistory(item) {
  if (!item || !item.id || !item.path) return readHistory();
  const entry = {
    id: item.id, label: item.label, type: item.type, path: item.path,
    at: Date.now(),
  };
  // Dedup by id, yang terbaru di depan. Menyimpan duplikat akan membuat satu
  // halaman yang sering dibuka memenuhi seluruh daftar.
  const next = [entry, ...readHistory().filter(x => x.id !== entry.id)].slice(0, MAX);
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* abaikan */ }
  return next;
}

export function clearHistory() {
  try { localStorage.removeItem(KEY); } catch { /* abaikan */ }
  return [];
}
